import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ActionTypes } from "src/store/constants";
import authChannel from "src/helpers/authChannel";
import { isDevelopment } from "src/module/helpers";

export default function useAuthGlobalListener(enabled = true) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!enabled) {
            return;
        }

        const unsubscribe = authChannel.subscribe((data) => {
            if (isDevelopment) {
                console.log("[AuthChannel]", data);
            }

            if (!data) return;

            if (data.type === "LOGOUT") {
                dispatch({ type: ActionTypes.LOGOUT });
            }

            if (data.type === "LOGIN") {
                window.location.reload();
            }
        });

        return () => {
            unsubscribe();
        };
    }, [dispatch, enabled]);
}
